import { useEffect, useState, useMemo, useCallback } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _RemoteAbstractAction, _single } from "../../../core/services/dataBean/EntityCatalog";
import { Slide, toast } from "react-toastify";
import { RemoteForm } from "./RemoteForm";
import { RemoteJsonForm } from "./RemoteJsonForm";
import { RemoteComponentProxy } from "./RemoteComponentProxy";
import { ExecBackAction } from "./ExecBackAction";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Props {
    remoteAbstractAction: any;
    isMenu?: boolean;
    returnProps?: any;
    mapData?: any;
    action?: any;
    lastStep?: any;

}

export const ExcecuteRemoteAbstract = ({ remoteAbstractAction, isMenu, returnProps, mapData, action, lastStep }: Props) => {
    const [remote, setRemote] = useState<any>(remoteAbstractAction);
    const [fire, setFire] = useState<any>({});
    const [slide, setSlide] = useState<any>({});
    const [response, setResponse] = useState<any>({});
    const [types, setTypes] = useState<any>([]);
    const [getN, setNext] = useState<boolean>(false);
    const { bean, setBean, instance } = useDataBean(_RemoteAbstractAction);
    const [keyStep, setKeyStep] = useState<number>(_single.getRandomInt());

    const initProps = useMemo(() => ({
        ...mapData,
        IDLoggedEmployee: _single.getAccountID()
    }), [mapData]);

    useEffect(() => {
        setRemote(remoteAbstractAction);
    }, [remoteAbstractAction]);

    useEffect(() => {
        if (remote.IDRemoteAbstractAction) {
            if (remote.IDApplicationInvoker) {
                setFire({ IDApplicationInvoker: remote.IDApplicationInvoker });
            } else {

                fireProcess();
            }
        }
    }, [remote]);

    useEffect(() => {
        if (fire.IDApplicationInvoker) {
            _single.printOut("FIRE =>");
            _single.printOut(fire);
            getNextStage();
        }
    }, [fire]);

    useEffect(() => {
        validateStep();
    }, [response]);

    useEffect(() => {
        _single.printOut("SLIDE => ");
        _single.printOut(slide.CLASSFORNAME);
        if (slide.TYPES) {
            setTypes(slide.TYPES);
            setNext(false);
            getRemoteAbstractActionProperties();
            setKeyStep(_single.getRandomInt());
        }
    }, [slide]);

    const getRemoteAbstractActionProperties = useCallback(() => {
        if (fire.IDApplicationInvoker) {
            instance.getRemoteAbstractActionProperties(fire.IDApplicationInvoker, _single.getAccountID())
                .then(resp => {

                    _single.printOut("PROPERTIES STEP => " + slide.CLASSFORNAME);
                    _single.printOut(slide);
                    _single.printOut(resp);
                    if (resp) {
                        if (returnProps) returnProps(resp);
                    }
                })
                .catch(err => console.error(err));
        }
    }, [fire.IDApplicationInvoker, instance, returnProps]);

    const fireProcess = useCallback(() => {
        if (isMenu) {
            instance.fireRemoteAbstractActionMenu(remote.ClassForName, remote.IDDocument, remote.Since, _single.getAccountID())
                .then(setFire)
                .catch(err => toast.error(err));
        } else {
            instance.fireRemoteAbstractActionBpm(remote.IDRemoteAbstractAction, _single.getAccountID(), initProps, action?.IDAction || null)
                .then(setFire)
                .catch(err => toast.error(err));
        }
    }, [remote, isMenu, initProps, action, instance]);

    const getNextStage = useCallback(() => {
        if (remoteAbstractAction.IDApplicationInvoker > 0) {
            instance.getRemoteAbstractActionCurrentStep(fire.IDApplicationInvoker, _single.getAccountID())
                .then(resp => {
                    _single.printOut("CURRENT NEXT => ");
                    _single.printOut(resp);
                    setSlide(resp);
                })
                .catch(err => toast.error(err));

        } else {
            instance.getRemoteAbstractActionNextStep(fire.IDApplicationInvoker, _single.getAccountID())
                .then(resp => {
                    _single.printOut("NEXT => ");
                    _single.printOut(resp);
                    setSlide(resp);
                })
                .catch(err => toast.error(err));
        }
    }, [fire]);


    const sendData = useCallback((e: any) => {
        if (e) {
            setBean(e);
            instance.setRemoteAbstractActionProperties(fire.IDApplicationInvoker, e, _single.getAccountID())
                .then(setResponse)
                .catch(err => toast.error(err));
        } else {
            toast.error("Sin datos para enviar!");
        }
    }, [fire.IDApplicationInvoker, instance, setBean]);

    const validateStep = useCallback(() => {
        _single.printOut("RESPONSE => ");
        _single.printOut(response);
        if (response.MESSAGE) toast.success(response.MESSAGE);
        if (types.includes(1)) sendData(bean);
        if (response.RESPONSE_ID === 1) getNextStage();
    }, [response, types, bean, sendData, getNextStage]);

    return (
        <div className="card">
            <div className="card-header" id={remote.ClassForName}>
                <h6 className="fs-15 mb-0">{slide.NAME || ''} </h6>
            </div>
            <div className="card-body">

                {!slide.TYPES ? (
                    slide.RESPONSE_ID === 1 ? (
                        <div className="alert alert-primary">
                            <strong>Tarea: </strong> Proceso completado.
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "10vh" }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Cargando...</span>
                            </div>
                        </div>
                    )
                ) : slide.TYPES.includes(0) ? (
                    slide.ABSTRACTSTEPTYPE === 4 ? (
                        <RemoteComponentProxy idApplicationInvoker={fire.IDApplicationInvoker} slide={slide} setData={sendData} />
                    ) : (
                        Object.keys(slide.PROPERTIES_STRUCTURE ?? {}).length > 0 ? (
                            <RemoteForm remote={remote} key={keyStep} useAsForm={false} idApplicationInvoker={fire.IDApplicationInvoker} fieldList={slide.PROPERTIES_STRUCTURE} data={slide.PROPERTIES} setData={sendData} />
                        ) : (
                            <RemoteJsonForm idApplicationInvoker={fire.IDApplicationInvoker} fieldList={slide.PROPERTIES_STRUCTURE} data={slide.PROPERTIES} setData={sendData} />
                        )
                    )
                ) : slide.TYPES.includes(1) && (
                    <ExecBackAction invoke={fire} isComplete={getNextStage} />
                )}
            </div>
        </div>

    );
};
